const longpress = {
  // 指令绑定到元素时触发
  bind: function (el, binding, vnode) {
    if (typeof binding.value !== 'function') {
      throw 'callback must be a function'
    }

    // 定义变量
    let pressTimer = null

    // 开始计时函数
    const start = (e) => {
      // 1. 判断是否为鼠标左键 (button === 0)
      // 2. 排除右键点击 (contextmenu) 或其他按键
      if (e.type === 'click' && e.button !== 0) {
        return
      }
      
      // 如果是 touchstart，不需要判断 button
      if (e.type === 'touchstart' && e.touches.length > 1) {
         return // 多指触摸不触发
      }

      // 清除之前的定时器（防止快速连续点击导致混乱）
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          // 执行绑定的函数
          handler(e)
        }, 800) // 这里设置长按时间，例如 800ms
      }
    }

    // 取消计时函数
    const cancel = (e) => {
      // 检查计时器是否存在
      if (pressTimer !== null) {
        clearTimeout(pressTimer)
        pressTimer = null
      }
    }

    // 运行函数
    const handler = (e) => {
      binding.value(e)
    }

    // 添加事件监听器
    // mousedown: 鼠标按下
    el.addEventListener('mousedown', start)
    // touchstart: 移动端触摸开始（兼容移动端）
    el.addEventListener('touchstart', start)

    // 取消事件监听器
    // click: 鼠标点击完成（短按会触发click，从而清除定时器）
    el.addEventListener('click', cancel)
    // mouseout: 鼠标移出元素
    el.addEventListener('mouseout', cancel)
    // touchend: 移动端触摸结束
    el.addEventListener('touchend', cancel)
    // touchcancel: 移动端触摸取消
    el.addEventListener('touchcancel', cancel)
    
    // 将清理函数挂载到元素上，方便 unbind 时移除
    el._longpress_start = start
    el._longpress_cancel = cancel
  },

  // 指令与元素解绑时触发
  unbind: function (el) {
    // 移除事件监听器，防止内存泄漏
    el.removeEventListener('mousedown', el._longpress_start)
    el.removeEventListener('touchstart', el._longpress_start)
    el.removeEventListener('click', el._longpress_cancel)
    el.removeEventListener('mouseout', el._longpress_cancel)
    el.removeEventListener('touchend', el._longpress_cancel)
    el.removeEventListener('touchcancel', el._longpress_cancel)
    
    // 清除可能残留的定时器
    if (el._longpress_timer) {
        clearTimeout(el._longpress_timer)
    }
  }
}

export default longpress